
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AttorneyProfile from './components/AttorneyProfile';
import ProblemsWeSolve from './components/ProblemsWeSolve';
import Partners from './components/Partners';
import PracticeAreas from './components/PracticeAreas';
import LeadCaptureForm from './components/LeadCaptureForm';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <AttorneyProfile />
      <ProblemsWeSolve />
      <Partners />
      <PracticeAreas />
      <LeadCaptureForm />
      <CallToAction />
      <Footer />
    </div>
  );
}
